import request from '@/utils/request'

export function updateSlotTestCfg(data) {
  return request({
    url: 'api/v1/slot-test/update',
    method: 'post',
    data: data
  })
}

export function updateSlotTestCfgCfg(data) {
  return request({
    url: 'api/v1/slot-test/updateCfg',
    method: 'post',
    data: data
  })
}

export function getSlotTestType(data) {
  return request({
    url: 'api/v1/slot-test/getType',
    method: 'post',
    data: data
  })
}

export function getSlotTestAllList(data) {
  return request({
    url: 'api/v1/slot-test/getAllCfgList',
    method: 'post',
    data: data
  })
}

export function getSlotTestMoodsList(data) {
  return request({
    url: 'api/v1/slot-test/getMoodsList',
    method: 'post',
    data: data
  })
}

export function getSlotTestUserList(data) {
  return request({
    url: 'api/v1/slot-test/getUserList',
    method: 'post',
    data: data
  })
}

export function getSlotTestList(data) {
  return request({
    url: 'api/v1/slot-test/getList',
    method: 'post',
    data: data
  })
}

export function getSlotTestCfgList(data) {
  return request({
    url: 'api/v1/slot-test/getCfgList',
    method: 'post',
    data: data
  })
}

export function delSlotTestList(data) {
  return request({
    url: 'api/v1/slot-test/delete',
    method: 'delete',
    data: data
  })
}

export function delSlotTestCfgList(data) {
  return request({
    url: 'api/v1/slot-test/deleteCfg',
    method: 'delete',
    data: data
  })
}

export function startSlotTest(data) {
  return request({
    url: 'api/v1/slot-test/start',
    method: 'post',
    data: data
  })
}

export function copySlotTest(data) {
  return request({
    url: 'api/v1/slot-test/copy',
    method: 'post',
    data: data
  })
}

export function viewSlotTest(data) {
  return request({
    url: 'api/v1/slot-test/view',
    method: 'post',
    data: data
  })
}

export function exportSlotTestMoods(data) {
  return request({
    url: 'api/v1/slot-test/exportMoods',
    method: 'post',
    data: data
  })
}

export function exportSlotTestRate(data) {
  return request({
    url: 'api/v1/slot-test/exportRate',
    method: 'post',
    data: data
  })
}
